import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const COMMUNICATION_CENTER_FILTERS = REPORTS_DEFAULT_FILTERS

export type CommunicationCenterKpiFormat = 'count' | 'percent' | 'duration'

export const COMMUNICATION_CENTER_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: CommunicationCenterKpiFormat
  unitInline?: string
  tone?: 'positive' | 'neutral'
}> = [
  {
    id: 'cc-total-calls',
    title: 'Total Calls',
    footer: 'Calls in period',
    format: 'count',
  },
  {
    id: 'cc-answered',
    title: 'Answered',
    footer: 'Primary volume',
    format: 'count',
  },
  {
    id: 'cc-missed',
    title: 'Missed',
    footer: 'Missed calls',
    format: 'count',
  },
  {
    id: 'cc-declined',
    title: 'Declined',
    footer: 'Needs callbacks',
    format: 'count',
  },
  {
    id: 'cc-followups',
    title: 'Follow-ups',
    footer: 'Follow-up required',
    format: 'count',
  },
  {
    id: 'cc-sentiment',
    title: 'Sentiment',
    footer: 'Dominant share',
    format: 'percent',
    tone: 'positive',
  },
  {
    id: 'cc-avg-time',
    title: 'Avg. Handling Time',
    footer: 'Per answered call',
    format: 'duration',
  },
]

export type CommunicationEffectivenessRow = {
  id: string
  /** Full name for tooltips / exports */
  label: string
  /** Two-line category label under each bar (horizontal, not angled) */
  labelLine1: string
  labelLine2: string
  rate: number
}

/** Vertical bar chart — rate as 0–100 for axis. Definition ids/labels only; rates come from API. */
export const COMMUNICATION_EFFECTIVENESS_BAR_DEFINITIONS: Array<
  Omit<CommunicationEffectivenessRow, 'rate'>
> = [
  {
    id: 'sms-open',
    label: 'SMS Open Rate',
    labelLine1: 'SMS',
    labelLine2: 'Open rate',
  },
  {
    id: 'sms-response',
    label: 'SMS Response Rate',
    labelLine1: 'SMS',
    labelLine2: 'Response rate',
  },
  {
    id: 'recall',
    label: 'Recall Campaign Reach',
    labelLine1: 'Recall campaign',
    labelLine2: 'Reach',
  },
  {
    id: 'reminder',
    label: 'Reminder Confirmation Rate',
    labelLine1: 'Reminder',
    labelLine2: 'Confirmation rate',
  },
]
